import { gql, useQuery } from '@apollo/client';

export type TenantRegistrationStatus = 'Pending' | 'Approved' | 'Rejected';

export const TENANT_REGISTRATION_REQUEST_FIELDS = gql`
  fragment TenantRegistrationRequestFields on TenantRegistrationRequest {
    id
    createdAt
    updatedAt
    status
    companyName
    website
    phone
    street
    zip
    city
    contactFirstName
    contactLastName
    contactEmail
    rejectionReason
    processedAt
    createdTenantCompanyId
    isEdited
  }
`;

export const GET_TENANT_REGISTRATION_REQUESTS = gql`
  ${TENANT_REGISTRATION_REQUEST_FIELDS}
  query GetTenantRegistrationRequests {
    tenantRegistrationRequests {
      ...TenantRegistrationRequestFields
    }
  }
`;

export interface TenantRegistrationRequest {
  id: string;
  createdAt: string;
  updatedAt?: string;
  status: TenantRegistrationStatus;
  companyName: string;
  website?: string;
  phone: string;
  street: string;
  zip: string;
  city: string;
  contactFirstName: string;
  contactLastName: string;
  contactEmail: string;
  rejectionReason?: string;
  processedAt?: string;
  createdTenantCompanyId?: string;
  isEdited: boolean;
}

export interface TenantRegistrationRequestsData {
  tenantRegistrationRequests: TenantRegistrationRequest[];
}

export function useTenantRegistrationRequestsQuery() {
  return useQuery<TenantRegistrationRequestsData>(GET_TENANT_REGISTRATION_REQUESTS, {
    fetchPolicy: 'cache-and-network',
  });
}
